var UitkCardContentSectionBorderMap = [
    ['top', 'block-start'],
    ['right', 'inline-end'],
    ['bottom', 'block-end'],
    ['left', 'inline-start']
];
var UitkCardContentSectionBorders = new Map(UitkCardContentSectionBorderMap);
var UitkCardContentSectionPaddingMap = [
    ['blockstart', 'block-start'],
    ['blockend', 'block-end'],
    ['inlinestart', 'inline-start'],
    ['inlineend', 'inline-end']
];
var UitkCardContentSectionPaddings = new Map(UitkCardContentSectionPaddingMap);
var UitkCardTagMap = [
    ['article', 'article'],
    ['aside', 'aside'],
    ['div', 'div'],
    ['footer', 'footer'],
    ['header', 'header'],
    ['section', 'section'],
    ['ul', 'ul'],
    ['ol', 'ol'],
    ['li', 'li']
];
var UitkCardTags = new Map(UitkCardTagMap);
var UitkCardPlaceholderStartPhaseMap = [
    ['dark', 'dark'],
    ['light', 'light']
];
var UitkCardPlaceholderStartPhases = new Map(UitkCardPlaceholderStartPhaseMap);
var UitkCardPlaceholderAspectRatioMap = [
    ['r1-1', 'ratio-1-1'],
    ['r1-2', 'ratio-1-2'],
    ['r1-3', 'ratio-1-3'],
    ['r1-4', 'ratio-1-4'],
    ['r1-5', 'ratio-1-5'],
    ['r1-6', 'ratio-1-6']
];
var UitkCardPlaceholderAspectRatios = new Map(UitkCardPlaceholderAspectRatioMap);
var UitkCardAspectRatioMap = [
    ['r1-1', 'ratio-1-1'],
    ['r1-2', 'ratio-1-2'],
    ['r1-3', 'ratio-1-3'],
    ['r1-4', 'ratio-1-4'],
    ['r1-5', 'ratio-1-5'],
    ['r1-6', 'ratio-1-6']
];
var UitkCardAspectRatios = new Map(UitkCardAspectRatioMap);
var UitkCardRoundCornersMap = [
    ['top-right', 'top-right'],
    ['top-left', 'top-left'],
    ['bottom-right', 'bottom-right'],
    ['bottom-left', 'bottom-left'],
    ['all', 'all']
];
var UitkCardRoundCorners = new Map(UitkCardRoundCornersMap);
var UitkCardFeaturedHeaderTitleTagMap = [
    ['h2', 'h2'],
    ['h3', 'h3'],
    ['h4', 'h4'],
    ['h5', 'h5'],
    ['h6', 'h6'],
    ['p', 'p']
];
var UitkCardFeaturedHeaderTitleTags = new Map(UitkCardFeaturedHeaderTitleTagMap);
var UitkCardBackgroundThemes = {
    PRIMARY: 'primary',
    SECONDARY: 'secondary',
    GLOBAL_LOYALTY_STANDARD: 'global-loyalty-standard',
    GLOBAL_LOYALTY_LOW: 'global-loyalty-low',
    GLOBAL_LOYALTY_MIDDLE: 'global-loyalty-middle',
    GLOBAL_LOYALTY_HIGH: 'global-loyalty-high',
    GLOBAL_LOYALTY_EXTRAHIGH: 'global-loyalty-extra-high'
};

export { UitkCardAspectRatios, UitkCardBackgroundThemes, UitkCardContentSectionBorders, UitkCardContentSectionPaddings, UitkCardFeaturedHeaderTitleTags, UitkCardPlaceholderAspectRatios, UitkCardPlaceholderStartPhases, UitkCardRoundCorners, UitkCardTags };
